import { api } from './base';

import { SlotMark } from 'v2/constants';
import { MutationArg, Pageable } from 'v2/types';
import { SlotFilter, ProviderSlotModel, SlotModel } from 'v2/types/SlotModel';
import { SWRKeyPaginationWithExtra, SWRKeyValue } from 'v2/types/swr';

export const slotService = {
  getSlots([_key, page, limit, filter]: SWRKeyPaginationWithExtra<SlotFilter>): Promise<Pageable<SlotModel>> {
    return api
      .get('v1/admin/provider-slot', {
        searchParams: { page, limit, filter: JSON.stringify(filter), sortFields: JSON.stringify({ order: 'asc' }) },
      })
      .json();
  },

  createSlot(_key: string, { arg }: MutationArg<Omit<SlotModel, 'id'>>): Promise<SlotModel> {
    return api.post('v1/admin/provider-slot', { json: arg }).json();
  },

  updateSlot([_key, slotId]: SWRKeyValue, { arg }: MutationArg<Omit<SlotModel, 'id'>>): Promise<SlotModel> {
    return api.put(`v1/admin/provider-slot/${slotId}`, { json: arg }).json();
  },

  updateSlotOrder([_key, slotId]: SWRKeyValue, { arg: order }: MutationArg<number>) {
    return api.patch(`v1/admin/provider-slot/${slotId}/order`, { json: { order } }).json();
  },

  updateSlotStatus([_key, slotId]: SWRKeyValue, { arg: isActive }: MutationArg<boolean>): Promise<SlotModel> {
    return api.patch(`v1/admin/provider-slot/${slotId}/active`, { json: { isActive } }).json();
  },

  updateSlotMarks([_key, slotId]: SWRKeyValue, { arg }: MutationArg<SlotMark[]>): Promise<SlotModel> {
    return api.patch(`v1/admin/provider-slot/${slotId}/marks`, { json: { marks: arg } }).json();
  },

  resetSlotsMarks(_key: string, { arg }: MutationArg<SlotMark[]>): Promise<void> {
    return api.patch('v1/admin/provider-slot/marks/reset', { json: { marks: arg } }).json();
  },

  getSyncSlots(): Promise<ProviderSlotModel[]> {
    return api.get('v1/admin/provider-slot/new', { timeout: 300_000 }).json();
  },
};
